import { EVENT_NAMES, EVENT_CATEGORIES, HIT_TYPE, TARGETS } from 'app-webtech-core/beacon/const';
import { getCmFields } from './helpers/getCmFields';
import { getPlaybackData } from '../../../player/beacons/helpers/getPlaybackData';

// eslint-disable-next-line no-unused-vars
export const cmErrorBeacon = (action, prevState, nextState) => {
  const { payload } = action;
  const { adBreakDuration, ad, adIndex } = payload;
  const cmFields = getCmFields({ adBreakDuration, ad, adIndex });
  return {
    hitType: HIT_TYPE.EVENT,
    targets: [TARGETS.PLUTO, TARGETS.MSN],
    eventCategory: EVENT_CATEGORIES.CM,
    eventName: EVENT_NAMES.CM_ERROR,
    label: payload && payload.type ? payload.type : 'Generic Error',
    value: payload && payload.message ? payload.message : JSON.stringify(action),
    ...cmFields,
    ...getPlaybackData(nextState),
  };
};
